import {Link} from "react-router-dom";
import React from "react";
import {TFunction} from "react-i18next";
import {ContainerItem} from "../../models/container/container-item";
import {Date} from "../core/commons/date/date";
import {ColumnsType} from "antd/es/table";
import {InTransitToCart} from "./in-transit.to-cart";
import {CatalogByOEMItem} from "../../models/articles/catalog/search";
import {Space} from "antd";
import {AddToCartAction} from "../catalog/ui/button/add-to-cart-action/add-to-cart-action";
import {AddToWishlistAction} from "../catalog/ui/button/add-to-wishlist-action/add-to-cart-action";

export const columnsFactory = (t: TFunction): ColumnsType<ContainerItem> => [
    {
        title: t("ARTICLES.TITLE_SINGLE"),
        dataIndex: "articleName",
        key: "articleName",
        render: (item: string) => <Link to={"/catalog/article/" + item} className="link article-link">{item}</Link>
    },
    {
        title: t("DESCRIPTION"),
        dataIndex: "description",
        key: "description"
    },
    {
        title: t("QUANTITY"),
        dataIndex: "qty",
        key: "qty"
    },
    {
        title: t("ARRIVAL_DATE"),
        key: "date",
        render: (_: any, item: ContainerItem) => <>
            <Date dateString={item.minimalDate} />
            {item.maximalDate !== item.minimalDate ? (
                <> ... <Date dateString={item.maximalDate} /></>
            ) : null}
        </>
    },
    {
        title: "",
        key: "actions",
        width: "100px",
        className: "catalog-table-btn",
        render: (_: any, row: ContainerItem) => (
            <Space direction={"horizontal"} size={[20, 20]}>
                <AddToCartAction article={row} type={"reservation"} />
                <AddToWishlistAction article={row} />
            </Space>

        )
    }
];